import axios from 'axios'
import { KeyRound } from 'lucide-react'
import { useState } from 'react'
import { constants } from '../../Constants'
import { Button, Modal } from '../ui'
import { useToast } from '../ui/Toast/Toast'

export const AlertDialogResendPassword = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const toast = useToast()

  const handleResend = async () => {
    setLoading(true)
    try {
      const response = await axios.post(`${constants.urlLocal}resendPassword`, {
        userId: user._id,
      })
      if (response.data.ok) {
        toast({
          title: 'Contraseña enviada correctamente',
          description: `Se ha enviado una nueva contraseña a ${user.email}`,
          status: 'success',
        })
        setIsOpen(false)
      } else {
        toast({
          title: 'Error al enviar la contraseña',
          description: response.data.message,
          status: 'error',
        })
      }
    } catch (error) {
      toast({
        title: 'Error al enviar la contraseña',
        description:
          error.response?.data?.message || 'Error de conexión con el servidor',
        status: 'error',
      })
    }
    setLoading(false)
  }

  return (
    <>
      <button
        className="icon-btn icon-btn--primary"
        onClick={() => setIsOpen(true)}
        title="Enviar nueva contraseña"
        aria-label="Enviar nueva contraseña"
      >
        <KeyRound size={16} />
      </button>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={`Enviar nueva contraseña`}
        size="sm"
      >
        <p>
          Se generará una nueva contraseña y se enviará al correo de{' '}
          <strong>
            {user.name} {user.lastname}
          </strong>{' '}
          ({user.email}).
        </p>
        <p style={{ fontSize: '0.85rem', color: '#888', marginTop: '0.5rem' }}>
          El usuario deberá cambiarla tras iniciar sesión.
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
            marginTop: '1.5rem',
          }}
        >
          <Button variant="ghost" onClick={() => setIsOpen(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleResend} loading={loading}>
            Enviar contraseña
          </Button>
        </div>
      </Modal>
    </>
  )
}
